/*
 * Reserve Now — shared popup logic.
 * Buttons: snippets/reserve-now.liquid. Popup: snippets/reserve-now-modal.liquid.
 * Saves the request with Shopify's native customer form (no app, no backend).
 */
(function () {
  'use strict';
  if (window.__reserveNowReady) return;
  window.__reserveNowReady = true;

  var PENDING_KEY = 'rn-pending';
  var PHONE_RE = /^[6-9][0-9]{9}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var modal, dialog, form;
  var ctx = null; // { title, optionName, single, variants, variantId }
  var opener = null;
  var busy = false;

  function $(sel) {
    return modal.querySelector(sel);
  }

  // Tags are comma separated, max 255 chars each.
  function tagSafe(value) {
    return String(value || '').replace(/[,\n\r]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
  }

  function findVariant(id) {
    for (var i = 0; i < ctx.variants.length; i++) {
      if (String(ctx.variants[i].id) === String(id)) return ctx.variants[i];
    }
    return ctx.variants[0] || null;
  }

  /* ---------------------------------------------------------- context */

  function contextFromButton(btn) {
    var variants = [];
    try {
      variants = JSON.parse(btn.parentNode.querySelector('[data-rn-variants]').textContent);
    } catch (e) {}

    // Selected variant = the add-to-cart form's id input, read at click time.
    var formEl = document.getElementById(btn.dataset.rnFormId);
    var hasForm = !!(formEl && formEl.tagName === 'FORM');
    var input = hasForm ? formEl.querySelector('input[name="id"]') : null;

    return {
      title: btn.dataset.rnTitle || '',
      optionName: btn.dataset.rnOptionName || 'Size',
      single: btn.dataset.rnSingle === 'true',
      variants: variants,
      variantId: (input && input.value) || btn.dataset.rnDefaultVariant,
      showSelect: !hasForm && variants.length > 1,
    };
  }

  function renderProduct() {
    var v = findVariant(ctx.variantId);
    if (v) ctx.variantId = String(v.id);
    $('[data-rn-product-title]').textContent = ctx.title;
    var showVariant = v && !ctx.single && v.title !== 'Default Title';
    $('[data-rn-variant-wrap]').hidden = !showVariant;
    $('[data-rn-variant-title]').textContent = showVariant ? v.title : '';
    $('[data-rn-price]').textContent = v ? v.price : '';
    var img = $('[data-rn-image]');
    if (v && v.image) {
      img.src = v.image;
      img.alt = ctx.title;
      img.hidden = false;
    } else {
      img.hidden = true;
    }
  }

  function renderSelect() {
    var field = $('[data-rn-variant-field]');
    field.hidden = !ctx.showSelect;
    if (!ctx.showSelect) return;
    $('[data-rn-variant-label]').textContent = ctx.optionName;
    var select = $('[data-rn-variant-select]');
    select.innerHTML = '';
    ctx.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = v.title + ' — ' + v.price;
      if (String(v.id) === String(ctx.variantId)) opt.selected = true;
      select.appendChild(opt);
    });
  }

  /* -------------------------------------------------------- UI state */

  function setError(name, message) {
    var span = $('[data-rn-error-for="' + name + '"]');
    var input = $('[data-rn-' + name + ']');
    if (span) span.textContent = message || '';
    if (input) {
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }
  }

  function setFormError(message) {
    var el = $('[data-rn-form-error]');
    el.textContent = message || '';
    el.hidden = !message;
  }

  // The button is not `disabled` while loading: Shopify's captcha may need to
  // re-submit the form through it. Repeat clicks are blocked via `busy`.
  function setLoading(loading) {
    busy = loading;
    var btn = $('[data-rn-submit]');
    btn.setAttribute('aria-disabled', loading ? 'true' : 'false');
    btn.classList.toggle('is-loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function showSuccess() {
    var v = ctx ? findVariant(ctx.variantId) : null;
    var line = ctx ? ctx.title : '';
    if (v && ctx && !ctx.single && v.title !== 'Default Title') line += ' · ' + v.title;
    $('[data-rn-success-product]').textContent = line;
    $('[data-rn-body]').hidden = true;
    $('[data-rn-success]').hidden = false;
    var close = $('[data-rn-success] [data-rn-close]');
    if (close) close.focus();
  }

  function show(success) {
    $('[data-rn-body]').hidden = false;
    $('[data-rn-success]').hidden = true;
    modal.hidden = false;
    document.body.classList.add('rn-open');
    if (success) return showSuccess();
    var first = ctx && ctx.showSelect ? $('[data-rn-variant-select]') : $('[data-rn-name]');
    if (typeof window.trapFocus === 'function') window.trapFocus(dialog, first);
    else first.focus();
  }

  function open(btn) {
    opener = btn;
    ctx = contextFromButton(btn);
    setFormError('');
    ['name', 'phone', 'email', 'address'].forEach(function (n) {
      setError(n, '');
    });
    var serverError = $('[data-rn-server-error]');
    if (serverError) serverError.remove();
    delete form.dataset.rnReady;
    setLoading(false);
    renderSelect();
    renderProduct();
    show(false);
  }

  function close() {
    if (busy || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('rn-open');
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(opener);
    else if (opener && opener.focus) opener.focus();
  }

  /* ---------------------------------------------------------- submit */

  function validate() {
    var name = $('[data-rn-name]').value.trim();
    var phone = $('[data-rn-phone]').value.replace(/\D/g, '');
    if (phone.length === 12 && phone.indexOf('91') === 0) phone = phone.slice(2);
    if (phone.length === 11 && phone.charAt(0) === '0') phone = phone.slice(1);
    var email = $('[data-rn-email]').value.trim();
    var address = $('[data-rn-address]').value.replace(/\s+/g, ' ').trim();

    setError('name', name ? '' : 'Please enter your full name.');
    setError('phone', PHONE_RE.test(phone) ? '' : 'Please enter a valid 10-digit mobile number.');
    setError('email', EMAIL_RE.test(email) ? '' : 'Please enter a valid email address.');
    setError('address', address.length >= 10 ? '' : 'Please enter your full address.');

    if (!name) return $('[data-rn-name]').focus(), null;
    if (!PHONE_RE.test(phone)) return $('[data-rn-phone]').focus(), null;
    if (!EMAIL_RE.test(email)) return $('[data-rn-email]').focus(), null;
    if (address.length < 10) return $('[data-rn-address]').focus(), null;
    return { name: name, phone: phone, email: email, address: address };
  }

  function fillHidden(data) {
    var parts = data.name.split(/\s+/);
    var v = findVariant(ctx.variantId);
    var tags = ['reserve', 'product:' + tagSafe(ctx.title)];
    if (v && !ctx.single && v.title !== 'Default Title') tags.push('variant:' + tagSafe(v.title));
    tags.push('phone:' + data.phone);
    // Commas would split the tag, so they become " /".
    tags.push('address:' + tagSafe(data.address.replace(/\s*,\s*/g, ' / ')));
    $('[data-rn-first]').value = parts.shift();
    $('[data-rn-last]').value = parts.join(' ');
    $('[data-rn-email]').value = data.email;
    $('[data-rn-tags]').value = tags.join(', ');
  }

  /*
   * Submission is a normal form post, NOT fetch: the store has Shopify's
   * spam protection on, and its captcha script only adds the required token
   * during a real browser submit ("Missing CAPTCHA token" otherwise).
   * Shopify saves the customer and reloads the page with ?customer_posted=true;
   * restoreAfterReload() then reopens the popup on the thank-you message.
   */
  var loadingTimer = null;

  function prepare() {
    setFormError('');
    var data = validate();
    if (!data) return false;
    fillHidden(data);
    try {
      sessionStorage.setItem(PENDING_KEY, JSON.stringify({ ctx: ctx, at: Date.now() }));
    } catch (e) {}
    return true;
  }

  function startLoading() {
    // Next tick, so the browser's own submission is not affected.
    setTimeout(function () {
      setLoading(true);
    }, 0);
    clearTimeout(loadingTimer);
    // If the captcha is closed without completing, let the shopper try again.
    loadingTimer = setTimeout(function () {
      setLoading(false);
    }, 30000);
  }

  // Validation runs on the submit button's click, which happens before the
  // submit event (also for Enter key submissions), so an invalid form is
  // never handed to Shopify's captcha.
  function onSubmitClick(e) {
    if (busy || !ctx) {
      e.preventDefault();
      return;
    }
    if (!prepare()) {
      e.preventDefault();
      return;
    }
    form.dataset.rnReady = 'true';
    startLoading();
  }

  // Safety net for submissions that did not come through the button.
  // Never blocks a submit that already passed validation.
  function onSubmit(e) {
    if (form.dataset.rnReady === 'true') return;
    if (!ctx || !prepare()) {
      e.preventDefault();
      return;
    }
    form.dataset.rnReady = 'true';
    startLoading();
  }

  /* ------------------------------------------------------------ init */

  function restoreAfterReload() {
    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
    } catch (e) {}
    var posted = !!$('[data-rn-posted]') || /customer_posted=true/.test(window.location.search);
    var serverError = $('[data-rn-server-error]');
    if (!posted && !serverError) return; // keep the pending state, e.g. while on the captcha page
    try {
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    if (!saved || !saved.ctx || Date.now() - (saved.at || 0) > 30 * 60 * 1000) return;
    ctx = saved.ctx;
    renderSelect();
    renderProduct();
    show(posted && !serverError);
  }

  function init() {
    modal = document.getElementById('ReserveNowModal');
    if (!modal) return;
    dialog = modal.querySelector('[role="dialog"]');
    form = modal.querySelector('[data-rn-form]');

    form.addEventListener('submit', onSubmit);
    $('[data-rn-submit]').addEventListener('click', onSubmitClick);
    $('[data-rn-variant-select]').addEventListener('change', function (e) {
      ctx.variantId = e.target.value;
      renderProduct();
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rn-close]')) close();
    });
    modal.addEventListener('input', function (e) {
      delete form.dataset.rnReady;
      if (e.target.matches('[data-rn-phone]')) e.target.value = e.target.value.replace(/[^\d+\s-]/g, '');
      ['name', 'phone', 'email', 'address'].forEach(function (n) {
        if (e.target.matches('[data-rn-' + n + ']')) setError(n, '');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    // Delegated: works for cards added later (filters, infinite scroll, quick add).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rn-open]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn);
    });

    restoreAfterReload();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
